import React from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';
import SvgLoader from '../media/MediaSvgLoader';
import { capitalize } from '../../../helpers/str';

const componentName = 'TabItem';
const TabItem = React.forwardRef((props, ref) => {
  const {
    label,
    identifier,
    colorScheme,
    onClick,
    onKeyDown,
    theme,
    isActive,
    tabIndex,
  } = props;

  return (
    <button
      ref={ref}
      type="button"
      role="tab"
      aria-selected={isActive}
      aria-controls={`tabpanel-${identifier}`}
      id={`tab-${identifier}`}
      tabIndex={tabIndex}
      className={suitcss({
        componentName,
        modifiers: [
          isActive && 'active',
          colorScheme && `theme${capitalize(colorScheme)}`,
          theme,
        ],
      })}
      onClick={() => onClick(identifier)}
      onKeyDown={onKeyDown}
      key={identifier}
    >
      {theme === 'icons' && <SvgLoader path={`/icons/icon-${isActive ? 'active' : 'inactive'}.svg`} inverted={colorScheme === 'dark'} />}
      {label}
    </button>
  );
});

TabItem.displayName = 'TabItem';

TabItem.propTypes = {
  identifier: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  colorScheme: PropTypes.oneOf(['dark', 'none', 'light']),
  theme: PropTypes.oneOf(['default', 'switch', 'icons', 'underlined']),
  isActive: PropTypes.bool,
  tabIndex: PropTypes.number,
};

export default TabItem;
